// TelcoTrack — polygon Documents: create chooser + typed document kinds.

/** Document-service `documents.type` for předání povrchů. */
export const SURFACE_HANDOVER_DOCUMENT_TYPE = 'SURFACE_HANDOVER' as const;

/** Document-service `documents.type` for digitální „Prázdná smlouva“. */
export const BLANK_CONTRACT_DOCUMENT_TYPE = 'BLANK_CONTRACT' as const;

/** Document-service `documents.type` for potvrzení předání odpovědnosti stavbyvedoucímu. */
export const RESPONSIBILITY_HANDOVER_DOCUMENT_TYPE = 'RESPONSIBILITY_HANDOVER' as const;

/** Create-chooser options under Dokumenty „+“ (typed protocols; upload is separate). */
export const POLYGON_DOCUMENT_CREATE_OPTIONS = [
  {
    id: 'predani_povrchu',
    label: 'Předání povrchů',
    documentType: SURFACE_HANDOVER_DOCUMENT_TYPE,
  },
  {
    id: 'predani_odpovednosti',
    label: 'Předání odpovědnosti',
    documentType: RESPONSIBILITY_HANDOVER_DOCUMENT_TYPE,
  },
  {
    id: 'prazdna_smlouva',
    label: 'Prázdná smlouva',
    documentType: BLANK_CONTRACT_DOCUMENT_TYPE,
  },
] as const;

/** Label for the free-file upload entry in the same „+“ menu. */
export const POLYGON_DOCUMENT_UPLOAD_OPTION_LABEL = 'Nahrát dokument';

export type PolygonDocumentCreateOptionId =
  (typeof POLYGON_DOCUMENT_CREATE_OPTIONS)[number]['id'];

/** Fixed předávající company block (mustr Pedvacprotokol). */
export const PREDANI_POVRCHU_PREDAVAJICI = {
  company: 'ProTelco s.r.o.',
  address: 'Máchova 316/1, 410 02 Lovosice',
} as const;

/**
 * Legal entity for warehouse goods-issue „Odkud“ (vydávající sklad / ProTelco).
 * IČO matches ARES / dodací listy (odběratel ProTelco). Override via env on BE if needed.
 */
export const WAREHOUSE_GOODS_ISSUE_ISSUER = {
  name: 'ProTelco s.r.o.',
  ico: '06605176',
  address: 'Máchova 316/1, 410 02 Lovosice',
} as const;

/** Default Drive file title prefix. */
export const PREDANI_POVRCHU_DRIVE_TITLE_PREFIX = 'Předání povrchů';

/** Default Drive file title prefix for blank digital contract. */
export const BLANK_CONTRACT_DRIVE_TITLE_PREFIX = 'Prázdná smlouva';

/** Default Drive file title prefix for responsibility handover. */
export const RESPONSIBILITY_HANDOVER_DRIVE_TITLE_PREFIX = 'Předání odpovědnosti';

/** Zakázky Drive skeleton key (`03_REALIZACE/08_Předání_odpovědnosti`). */
export const RESPONSIBILITY_HANDOVER_DRIVE_ARTIFACT = 'responsibilityHandover' as const;
